import { TAX_ENTITY_TYPES } from '@/features/taxes/taxConstants'

/**
 * The practice-setup options signup offers, and the only values the rest of the app
 * recognizes for `financial_profiles.business_entity`.
 *
 * Shared rather than redeclared: any flow that collects this answer must write the same
 * vocabulary, or it persists values nothing downstream understands.
 */
export const BUSINESS_ENTITY_OPTIONS = {
  sprop: 'Sole Proprietor',
  llc_single: 'LLC',
  pllc_single: 'PLLC',
  c_corp: 'Corporation',
  other: 'Other',
} as const

/** The tax-entity options signup offers. Note `other`, which is normalized on write. */
export const TAXED_AS_TYPE = {
  form_1040: 'Sole Proprietor',
  form_1120_s: 'S Corporation',
  form_1120: 'C Corporation',
  other: 'Other',
} as const

/**
 * `other` is an answer the form offers but not a value the profile stores — it is
 * persisted as Schedule C. Any flow writing this field must apply the same mapping.
 */
export const normalizeTaxEntityType = (
  taxEntityType: TAX_ENTITY_TYPES | 'other'
): TAX_ENTITY_TYPES =>
  taxEntityType === 'other' ? TAX_ENTITY_TYPES.schedule_c : taxEntityType
